import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import HistoricGraphs from './HistoricGraphs';
import { useMemo, useState } from 'react';
import { Flex, DisplaySwitch } from '@blockanalitica/ui';

export default function HistoricTabs({ address }) {
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const [activeDisplayOption, setActiveDisplayOption] =
    useState('total_balance');
  const [data, error] = useApi({
    url: `/tokens/arbitrum/${address}/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  const displayOptions = useMemo(
    () => [
      { key: 'total_balance', value: 'Supply' },
      { key: 'market_cap', value: 'Market Cap' },
      { key: 'price', value: 'Price' }
    ],
    []
  );

  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  if (error) {
    throw error;
  }

  let content;
  if (data) {
    content = (
      <HistoricGraphs
        data={data}
        address={address}
        timeFilter={timeFilter}
        chartDaysAgo={chartDaysAgo}
        activeDisplayOption={activeDisplayOption}
      />
    );
  } else {
    content = <ChartSkeleton />;
  }

  return (
    <Flex flexDirection="column" gap="xs">
      <DisplaySwitch
        data={displayOptions}
        activeOption={activeDisplayOption}
        onChange={setActiveDisplayOption}
      />
      {content}
    </Flex>
  );
}
